
import { supabase } from '@/integrations/supabase/client';
import { PricingPlan, pricingPlans, modelComparisonData } from '@/config/pricingPlans';

/**
 * Get all pricing plans from static config
 */
export const fetchAllPlans = async (): Promise<PricingPlan[]> => {
  console.log('Using static pricing plans');
  return Object.values(pricingPlans);
};

/**
 * Use static plans instead of database plans
 */
export const useStaticPlans = (): PricingPlan[] => {
  console.log('Using static pricing plans');
  return Object.values(pricingPlans);
};

/**
 * Fetch a specific plan by ID from static config
 */
export const fetchPlanById = async (planId: string): Promise<PricingPlan | null> => {
  if (!planId) {
    console.error('No plan ID provided to fetchPlanById');
    return null;
  }
  
  console.log(`Getting plan with ID "${planId}" from static config`);
  return pricingPlans[planId] || null;
};

/**
 * Get model comparison data from static config
 */
export const fetchModelComparisonData = async () => {
  console.log('Using static model comparison data');
  return modelComparisonData;
};

